/**
 * remove single key-value-pair from query string
 * @param {String} uri uri to parse
 * @param {String} key key to remove
 * @returns {String}  uri without key
 */
export default function removeQueryStringParameter(uri, key) {
	const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');

	return uri.match(re) ?
		uri
			.replace(re, '$1') // remove key if exists
			.replace(/[?&]$/, '') : // remove trailing separator
		uri;
}
